import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import axios from 'axios';

interface IClientFilter {
  id: number;
  name: string;
}

export const fetchData = async (query = ''): Promise<ISelectOption[]> => {
  const response = await api.get<IClientFilter[]>(`${BI_BASE_URL}/helpers/search/clients/`, {
    params: {
      client_query: query,
    },
  });
  const data = response.data ?? [];

  return data.map(item => ({
    value: `${item.id}`,
    label: item.name,
  }));
};

export const useClientOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => {
      if (axios.isCancel(error)) return;
      errorHandler(error);
    },
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
